<template>
  <a-table
    id="tableDataTabs"
    :columns="columns"
    :dataSource="tableData"
    :pagination="false"
    bordered> </a-table>
</template>
<script>
import { getAssetDepreciationParameters } from '@/api/assetLedger'
export default {
  props: {
    model: Object
  },
  watch: {
    model: {
      handler (model) {
        console.log('接口', model)
        this.initTableData(model)
      },
      immediate: true
    }
  },
  data () {
    return {
      columns: [
        {
          title: '序号',
          customRender: (text, record, index) => {
            return index + 1
          },
          width: 50
        },
        {
          title: '范围编号',
          dataIndex: 'afabe',
          align: 'center'
        },
        {
          title: '折旧范围',
          dataIndex: 'zjfw',
          align: 'center'
        },
        {
          title: '折旧码',
          dataIndex: 'afasl',
          align: 'center'
        },
        {
          title: '使用年限',
          dataIndex: 'ndjar',
          align: 'center'
        },
        {
          title: '期间',
          dataIndex: 'ndper',
          align: 'center'
        },
        {
          title: '普通折旧开始日期',
          dataIndex: 'afabg',
          align: 'center'
        }
      ],
      tableData: []
    }
  },
  methods: {
    // 获取表格数据
    initTableData (model) {
      const params = {
        anln1: model.anln1,
        bukrs: model.bukrs,
        anln2: model.anln2
      }
      getAssetDepreciationParameters(params).then((res) => {
        // console.log('数据', res.data)
        if (res.status === 0) {
          this.tableData = res.data
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.table /deep/ .ant-table-thead > tr > th {
  background: #E7F4FF !important;
  padding: 10px !important;
}
.table /deep/ .ant-table-tbody > tr > td {
  padding: 10px;
}
/deep/.ant-table-placeholder {
  position: relative !important;
}
#tableDataTabs  {
  /deep/.ant-spin-nested-loading {
    >.ant-spin-container {
      .ant-table-bordered {
        .ant-table-header > table{
          border-top: 1px solid #e8e8e8;
          border-left: 1px solid #e8e8e8;
        }
        .ant-table-thead > tr > th{
          border-right: 1px solid #e8e8e8;
        }
        .ant-table-body > table{
          border-top: 1px solid #e8e8e8;
          border-left: 1px solid #e8e8e8;
        }
        .ant-table-tbody > tr > td{
          border-right: 1px solid #e8e8e8;
          border-bottom: 1px solid #e8e8e8;
        }
        .ant-table-tbody > tr.ant-table-row-selected td{
          background-color: rgba(225, 225, 225, 0);
        }
        .ant-table-footer{
          border: none !important;
        }
      }
    }
  }
}
</style>
